"use strict";

/**
 * @generated SignedSource<<dc19f569c4ac2a18b54cf1ce716dd3b4>>
 * @relayHash fed9cf2efcdd61589941a54ea48af5bf
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 33770290874f361cb99962923fd0eaa87078efbf5f30a05cbb997c50f4912853

const node = function () {
  var v0 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dbId",
      "storageKey": null
    },
    v1 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    v3 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    v5 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "team",
      "storageKey": null
    },
    v6 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "ViewerAccountProviderQuery",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, {
          "kind": "ClientExtension",
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "ClientPreferences",
            "kind": "LinkedField",
            "name": "clientPreferences",
            "plural": false,
            "selections": [{
              "args": null,
              "kind": "FragmentSpread",
              "name": "useClientPreferences_ClientPreferences"
            }],
            "storageKey": null
          }]
        }],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "ViewerAccountProviderQuery",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, v6 /*: any*/, {
          "kind": "ClientExtension",
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "ClientPreferences",
            "kind": "LinkedField",
            "name": "clientPreferences",
            "plural": false,
            "selections": [{
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            }, {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "preferredSupplierId",
              "storageKey": null
            }, {
              "alias": null,
              "args": null,
              "concreteType": "DiscardedItem",
              "kind": "LinkedField",
              "name": "discardsBin",
              "plural": true,
              "selections": [v6 /*: any*/, {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              }, {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expiryTS",
                "storageKey": null
              }],
              "storageKey": null
            }, v6 /*: any*/],
            "storageKey": null
          }]
        }],
        "storageKey": null
      }]
    },
    "params": {
      "id": "33770290874f361cb99962923fd0eaa87078efbf5f30a05cbb997c50f4912853",
      "metadata": {},
      "name": "ViewerAccountProviderQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "3f3630939d5d0c234a53e98452a652d4";
export default node;